import styled from "styled-components";

// const

export const ProgressBarTitle = styled.span`
  text-align: right;
  font-size: 0.6rem;
  word-wrap: break-word;
	color: ${props => props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.5rem;
  }

  @media (max-width: 430px) {
    font-size: 0.35rem;
  }
`;

export const ProgressBarTitleSm = styled.span`
  
  text-align: right;
  font-size: 0.6rem;
  word-wrap: break-word;
	color: ${props => props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.5rem;
  }

  @media (max-width: 430px) {
    font-size: 0.35rem;
  }
`;

export const ProgressBarTitleMd = styled.span`
  
  text-align: right;
  font-size: 0.8rem;
  word-wrap: break-word;
	color: ${props => props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }

  @media (max-width: 430px) {
    font-size: 0.5rem;
  }
`;

export const ProgressBarTitleLg = styled.span`
  //text-align: right;
  
  font-size: 1rem;
  word-wrap: break-word;
	color: ${props => props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }

  @media (max-width: 430px) {
    font-size: 0.6rem;
  }
`;

export const ProgressLabel = styled.div`
	//width: 15%;
	//padding-left: 3rem;


  @media (min-width: 1440px) {
    padding-left: unset;
  }
	
`

export const ProgressStat = styled.div`
	width: 10%;
	//padding-left: 1rem;
`